import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Web3 from 'web3';


@Component({
  selector: 'app-buy-modal',
  templateUrl: './buy-modal.component.html',
  styleUrls: ['./buy-modal.component.scss']
})
export class BuyModalComponent implements OnInit {
  
  @Input() asset: any = {};
  amount: number = 0;
  availablePercent: number = 0;
  tokensMinted: number = 100;
  inputMin : number = 0.1;
  inputMax: number = 0;
  error: any = {
    status: false,
    message: '',
  };
  buyPercent: number = 0;

  constructor(
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.asset.saleInfo.offer_amount = Number( Web3.utils.fromWei( this.asset.saleInfo.offer_amount ) );
    this.availablePercent = this.asset.saleInfo.offer_amount * 100 / this.tokensMinted;
    this.inputMax = this.availablePercent;
  }

  onChangeAmount( event: any ) {

    if( Number( event.target.value ) > this.availablePercent ) {
      this.error = {
        status: true,
        message: 'You can\'t buy more than the available percentage',
      };
    }else if( Number( event.target.value )*10 % 1 !== 0 ) {
      this.error = {
        status: true,
        message: `The amount must be a multiple of ${this.inputMin}%`
      };
    }
    else{
      this.error = {
        status: false,
        message: '',
      };
      this.buyPercent = Number( event.target.value );
      this.amount = Number( event.target.value ) * this.tokensMinted / 100;
      console.log('amount', this.amount);
    }
  }

  close() {
    this.activeModal.close( this.amount !== 0 ? this.amount : null );
  }
}
